module.exports = __webpack_public_path__ + "assets/img/BodyLux.87b35862.jpg";